<template>
  <base-card>
    <h1>
      User Profile for
      <div class="user-name">{{ userProfile.userName }}</div>
    </h1>
    <section v-if="userProfile === null">
      <p>No User Profile. Please create one.</p>
    </section>
    <section v-else>
      <ul class="profile__attributes">
        <li>
          User Name:
          <label>{{ userProfile.userName }}</label>
        </li>
        <li>
          Email:
          <label>{{ userProfile.email }}</label>
        </li>
        <li>
          Administrator:
          <label>{{ userProfile.isAdmin ? "Yes" : "No" }}</label>
        </li>
      </ul>
      <div>
        <base-button
          v-if="!editingProfile"
          link
          :to="editUserURL"
          @click="editingProfile = true"
          >Edit Profile</base-button
        >
      </div>
      <p class="date-added">User since {{ formattedDate(userProfile.dateAdded) }}</p>
    </section>
    <base-card v-if="editingProfile">
      <router-view @cancel="cancelData" @save-data="saveData"></router-view>
    </base-card>
  </base-card>
</template>

<script>
import DateFunctions from "./../../mixins/DateFunctions.js"

export default {
  mixins: [DateFunctions],
  computed: {
    userProfile() {
      return this.$store.getters.currentUser;
    },
    picksURL() {
      return "/users/" + this.id + "/picks";
    },
    editUserURL() {
      return "/users/" + this.id + "/edit";
    },
  },
  props: ["id"],
  data() {
    return {
      editingProfile: false,
    };
  },
  methods: {
    saveData(data) {
      console.log("In saveData, newUserName = " + data.userName + ", newEmail = " + data.email );
      this.$store.dispatch("updateUserProfile", data);
      this.editingProfile = false;
    },
    cancelData() {
      console.log("In cancelData");
      this.editingProfile = false;
    }

  }
};
</script>

<style scoped>
.user-name {
  display: inline-block;
  color: blue;
}

.profile__attributes {
  list-style: none;
}

.profile__attributes li {
  margin: 4px 4px;
}

.profile__attributes label {
  color: blue;
}

.edit-user {
  text-decoration: none;
  color: white;
}

.date-added {
  color: rgb(61, 61, 61);
  font-style: italic;
  text-align: center;
}
</style>